import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 1,
  sequence: 0,
  'filter[categoryids][0]': 4
};
import { threadList, banner } from '@/api/mg';
export default {
  data: function data() {
    return {
      totalPage: 0,
      loading: false,
      finished: false,
      isLoading: false,
      newsData: [],
      banner: [
        // { src: require('../../../assets/images/Banner1.png') },
        // { src: require('../../../assets/images/Banner2.png') }
      ],
      infos: [{
        isFollow: true
      }, {
        isFollow: false
      }, {
        isFollow: true
      }, {
        isFollow: false
      }]
    };
  },
  created: function created() {
    this.newsData = [];
    threadListParams.page = 1;
    this.getThreadList(threadListParams);
    this.getBanner({
      page: 1,
      perPage: 6
    });
  },
  methods: {
    toLink: function toLink(url) {
      // 未登录
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        if (window.Android) {
          if (token == '') {
            window.Android.unLogin();
          } else {
            window.Android.gotoWebView(url);
          }
        }
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        if (token == '') {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        } else {
          this.$bridge.callhandler('gotoWebView', url, function (res) {});
        }
      }
      // if (url) {
      //   location.href = url
      // }
    },
    getBanner: function getBanner(params) {
      var _this = this;
      banner(params).then(function (res) {
        if (res.Code === 0) {
          _this.banner = res.Data.pageData;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    onLoad: function onLoad() {
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
    },
    getThreadList: function getThreadList(params) {
      var _this2 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this2.$toast('No Data');
          }
          // this.newsData = []
          _this2.totalPage = res.Data.totalPage;
          _this2.newsData = [].concat(_toConsumableArray(_this2.newsData), _toConsumableArray(res.Data.pageData));
          _this2.newsData.forEach(function (itm) {
            itm.content.text = _this2.filter(itm.content.text);
            // 新闻默认背景图
            if (itm.content.indexes['101'] && itm.content.indexes['101'].body.length == 0) {
              var obj = {
                thumbUrl: './news_bg.png',
                type: 0
              };
              itm.content.indexes['101'].body.push(obj);
            }
          });
          console.log(_this2.newsData, 'this.newsData');
          _this2.loading = false;
          _this2.isLoading = false;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    filter: function filter(html) {
      return html.replace(/<(?:.|\n)*?>/gm, '').replace(/(&rdquo;)/g, '"').replace(/&ldquo;/g, '"').replace(/&mdash;/g, '-').replace(/&nbsp;/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/<[\w\s"':=\/]*/, '');
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
    },
    toDetail: function toDetail(threadId, postCount) {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
      } else {
        this.$router.push({
          path: '/social/detail',
          query: {
            from: 'news',
            threadId: threadId,
            postCount: postCount
          }
        });
      }
    }
  }
};